module.exports = __webpack_public_path__ + "static/media/search-empty.977b6036.gif";